import React from 'react'
import { Badge } from '@chakra-ui/react'

interface StatusBadgeProps {
  status: string
  variant?: 'solid' | 'subtle' | 'outline'
}

const statusColors: Record<string, string> = {
  draft: 'gray',
  pending_payment: 'yellow',
  creative_review: 'blue',
  active: 'green',
  paused: 'orange',
  completed: 'purple',
  failed: 'red',
  succeeded: 'green',
  pending: 'yellow',
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  variant = 'subtle',
}) => {
  const colorPalette = statusColors[status.toLowerCase()] || 'gray'
  const displayStatus = status
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

  return (
    <Badge colorPalette={colorPalette} variant={variant}>
      {displayStatus}
    </Badge>
  )
}

